export function Steps() {
    const steps = [
        { n: 1, title: "On en parle", desc: "Un échange (par téléphone, mail ou vidéo) pour comprendre votre activité : menu, horaires, branding." },
        { n: 2, title: "On configure", desc: "On paramètre votre app : vos produits, vos prix, vos couleurs, votre logo. Vous validez." },
        { n: 3, title: "C'est en ligne", desc: "Votre application est live. Vos clients la trouvent sur Google et l'installent sur leur téléphone." },
        { n: 4, title: "Vous vendez", desc: "Gérez tout depuis votre tableau de bord : commandes, fidélité, promos, analytics." },
    ];

    return (
        <section className="py-12 px-6" id="etapes">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Opérationnel en 48h.
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto leading-relaxed">
                    De l'appel découverte à la mise en ligne, tout se fait rapidement et simplement.
                </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-[1200px] mx-auto text-center">
                {steps.map((s, i) => (
                    <div key={s.n} className="relative">
                        {i < steps.length - 1 && (
                            <span className="hidden lg:block absolute -right-5 top-9 text-2xl text-slate-300 font-light">→</span>
                        )}
                        <div className="w-14 h-14 rounded-full bg-orange-500 text-white flex items-center justify-center text-[1.4rem] font-extrabold mx-auto mb-4">{s.n}</div>
                        <h3 className="text-[clamp(1.25rem,2.5vw,1.5rem)] font-extrabold text-slate-900 mb-2">{s.title}</h3>
                        <p className="text-[0.92rem] text-slate-500 leading-relaxed">{s.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
